"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_ACCESSIBILITY_GUIDELINES_TAGS = exports.AxeAccessibilityChecker = void 0;
var _react = _interopRequireDefault(require("react"));
/**
 *
 * @param getRules - Function that returns accessibility guidelines rules based on tags.
 * @param tags - Visit [axe-core-tags](https://www.deque.com/axe/core-documentation/api-documentation/#axe-core-tags) for allowed accessibility guidelines tags.
 * @returns Array of `Axe.Rule`
 */
const getRulesFromTags = (getRules, tags) => {
  const rules = getRules(tags);
  return rules.map(rule => ({
    ...rule,
    id: rule.ruleId,
    enabled: true
  }));
};
/**
 * Default accessibility guidelines tags used for axe-core.
 * @constant
 * @type {string[]}
 * @default ['wcag21aa', 'best-practice']
 */
const DEFAULT_ACCESSIBILITY_GUIDELINES_TAGS = exports.DEFAULT_ACCESSIBILITY_GUIDELINES_TAGS = ['wcag22aa', 'best-practice'];
/**
 * React Functional Component for integrating axe-core accessibility checks.
 * This will work also if we switch apps to `Next.js app folder` structure in the future.
 * Instead of using the example listed here: https://github.com/dequelabs/axe-core-npm/tree/develop/packages/react/examples/next.js which does not support `app folder` structure
 *
 * @example
 * // Usage example for the Axe component
 * <AxeAccessibilityChecker accessibilityGuidelinesTags={['wcag22aa', ...]} />
 *
 * @component
 * @param {object} props - The component props.
 * @param {string[]} [props.accessibilityGuidelinesTags = DEFAULT_ACCESSIBILITY_GUIDELINES_TAGS] - The tags defining which accessibility guidelines to enforce, visit [axe-core-tags](https://www.deque.com/axe/core-documentation/api-documentation/#axe-core-tags) for allowed accessibility guidelines tags.
 * @returns {null} This component does not render anything it just injects `@axe-core/react` into `dom`.
 *
 * @remarks
 * This component should only be used during development and will not run in production.
 * It dynamically imports `@axe-core/react` and `react-dom`, and configures axe-core with specified rules from provided tags.
 *
 * @async
 */
const AxeAccessibilityChecker = ({
  accessibilityGuidelinesTags = DEFAULT_ACCESSIBILITY_GUIDELINES_TAGS
}) => {
  if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
    void Promise.all([import('axe-core'), import('@axe-core/react'), import('react-dom')]).then(async ([axe, reactAxe, ReactDOM]) => reactAxe.default(_react.default, ReactDOM, 1000, {
      /* Can be extended if needed */
      rules: getRulesFromTags(axe.getRules, accessibilityGuidelinesTags),
      disableOtherRules: true
    }));
  }
  return null;
};
exports.AxeAccessibilityChecker = AxeAccessibilityChecker;
